export default {
    send_commands_title: "Send Command",
    send_commands_the_device_has_not_been_found: "The device has not been found",
    send_commands_the_device_has_already_been_added: "The device has already been added",
    send_commands_the_unit_type_of_the_device_must_bet_the_same: "The unit type of the devices must be the same",
    send_commands_the_manufacturer_of_the_devices_must_be_the_same: "The manufacturer of the devices must be the same",
    send_commands_imei_or_serial: "IMEI or Serial",
    send_commands_imei: "IMEI",
    send_commands_serial: "Serial",
    send_commands_model: "Model",
    send_commands_commands_sent: "Commands Sent",
    send_commands_status: "Status",
    send_commands_complete: "Complete",
    send_commands_send_more_commands: "Send More Commands",
    send_commands_mass_sms_title: "Mass SMS",
    send_commands_send: "Send",
    send_commands_command_to_send: "Command to send",
    send_commands_canned_commands: "Canned Commands",
    send_commands_phone_numbers: "Phone #'s",
    send_commands_unit_type: "Unit Type",
    send_commands_unit_types: "Unit Types",
    send_commands_device_models: "Device Models",
    send_commands_manufacturer_commands: "Manufacturer Commands",
    send_commands_unit_type_commands: "Unit Type Commands",
    send_commands_device_model_commands: "Device Model Commands",
    send_commands_error_phone_length: "Phone number length is not between 10 and 15 digits",
    send_commands_error_phone_not_number: "Phone number is not a valid number",
    send_commands_send_type: "Integration",
    send_commands_unvalid_phone_numbers: "There are not valid phone numbers to send the command",
    send_commands_errors: "Errors",
    send_commands_sent: "Command sent to",
    send_commands_error_duplicate_phone: "Duplicate phone number",
    send_commands_error_iccid_length: "ICCID length is not between 10 and 20 digits",
    send_commands_unvalid_iccid_numbers: "There are not valid ICCID's to send the command",
    send_commands_error_duplicate_iccid: "ICCID duplicate",
    send_commands_sms_activity: "SMS Activity",
    send_commands_update_sms_activity: "Update SMS Activity",
    send_commands_inbound: "Inbound",
    send_commands_outbound: "Outbound",
    send_commands_inbound_collapsed: "I",
    send_commands_outbound_collapsed: "O",
    send_commands_manufacturer: "Manufacturer",
    send_commands_click_to_copy: "Click to copy",
    send_commands_only_for_m2md: "HTTP command sending is only available for M2MD device",
    send_commands_http_validate_selection: "Select the canned command Locate to configure HTTP locate options",
    send_commands_canned_accuracy: "Accuracy",
    send_commands_canned_skip_wifi_on: "Skip WiFi On",
    send_commands_canned_skip_gps_on: "Skip GPS On",
    send_commands_canned_skip_wifi_off: "Skip WiFi Off",
    send_commands_canned_skip_gps_off: "Skip GPS Off",
    send_commands_canned_accuracy_maximum_value_500: "The maximum value for Accuracy is 500",
    send_commands_canned_accuracy_minimum_value_1: "The minimum value for Accuracy is 1",


}